import { ServiceManager, ServiceBusController, ServiceBusControllerBody } from '@estee/elc-service';
import { events, on, serviceQueries, queryProvider } from '@estee/elc-service-bus';

const onQuery = [[serviceQueries.IS_LOYALTY_MEMBER, 'isLoyaltyMember']];
const onEvents = [[events.LOYALTY_ACCOUNT_ENROLMENT, 'enrolmentIntoLoyalty']];

class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                onQuery.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
                onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
            }
        }, 50);
    };
}

export const serviceBusBaseClass = new ServiceBus() as ServiceBusControllerBody;
